import * as React from 'react'
import Image from 'next/image'
import { Fragment } from 'react'
import Link from 'next/link'
import { BlogPostType } from '../../pages/blog'
import { prop, reverse, sortBy } from 'ramda'
import { ButtonOutline } from '../Button'
import { mapIndexed } from '../../util/util'
import { useQueryParam } from '../../hooks/useQueryParam'
import { flow } from 'fp-ts/lib/function'

type Props = {
  posts: BlogPostType[]
}

const BlogRoll: React.FC<Props> = ({ posts }) => {
  const query = useQueryParam()
  return (
    <div>
      {posts &&
        flow<any, BlogPostType[], BlogPostType[], any>(
          sortBy(prop('published')),
          reverse,
          mapIndexed((post: BlogPostType, index) => {
            return (
              <Fragment key={index}>
                <div className="flex flex-col rounded mb-6 border border-gray-200">
                  <Image
                    className="w-full rounded-t"
                    alt={`featured image thumbnail for post ${post.title}`}
                    src={post.featured_image}
                    width={500}
                    height={300}
                    layout="responsive"
                  />
                  <div className="p-6">
                    <Link href={`/blog/[slug]`} as={{ pathname: `/blog/${post.slug}/`, query }}>
                      <a className="text-lg">{post.title}</a>
                    </Link>
                    <p>
                      <br />
                      <Link href={`/blog/[slug]`} as={{ pathname: `/blog/${post.slug}/`, query }}>
                        <a>
                          <ButtonOutline>Read More</ButtonOutline>
                        </a>
                      </Link>
                    </p>
                  </div>
                </div>
              </Fragment>
            )
          })
        )(posts)}
    </div>
  )
}

export default BlogRoll
